import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MaintenanceService } from './core/services/maintenance.service';
import { MaintenancePageComponent } from './features/maintenance/maintenance-page.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MaintenancePageComponent],
    template: `
      @if (maintenance.active()) {
        <app-maintenance-page />
      } @else {
        <router-outlet></router-outlet>
      }
    `
})
export class AppComponent {
  readonly maintenance = inject(MaintenanceService);
}
